// extracted by mini-css-extract-plugin
module.exports = {"noData":"noData___3d0B2","btn":"btn___gd61a"};